/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Badge_ResultsInputs */

const et_hero_badge_results = /** @type {(inputs: Hero_Badge_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välkkiired tulemused`)
};

const en_hero_badge_results = /** @type {(inputs: Hero_Badge_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lightning-fast results`)
};

/**
* | output |
* | --- |
* | "Lightning-fast results" |
*
* @param {Hero_Badge_ResultsInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_badge_results = /** @type {((inputs?: Hero_Badge_ResultsInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Badge_ResultsInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_badge_results(inputs)
	return en_hero_badge_results(inputs)
});